import { t } from '@lingui/macro';
import { Avatar, Chip, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { getMarketByCode } from 'app/domains/markets/config';
import Flag from 'shared/domains/languages/components/Flag';
import { CategoryChip } from '../../../CategoryChip';
import { getCategoryCover, getCategoryTypeFromId } from '../../../utils';
import { Container, Content, FlagsContainer, Header, MetaContainer, StyledTypography, } from './styled';
export function Item(props) {
    const { composer, onClick } = props;
    const { id, metadata, category, locked, language, templates = [] } = composer;
    const { name, description } = metadata[0];
    const templateCodes = (templates === null || templates === void 0 ? void 0 : templates.map(template => template.marketLocaleCode)) || [];
    const market = getMarketByCode(language === null || language === void 0 ? void 0 : language.marketCode);
    const categoryType = getCategoryTypeFromId((category === null || category === void 0 ? void 0 : category.id) || '');
    return (<Container onClick={() => onClick(id)}>
      <Header $svg={getCategoryCover(categoryType)}>
        <CategoryChip variant="outline" type={categoryType} label={category === null || category === void 0 ? void 0 : category.metadata[0].title}/>
        {locked && (<Avatar appearance="secondary">
            <Falcon icon="lock"/>
          </Avatar>)}
      </Header>
      <Content>
        <Typography $fontSize="medium" $appearance="300" $fontWeight="semibold">
          {name}
        </Typography>
        <StyledTypography $fontSize="small" $appearance="200">
          {description}
        </StyledTypography>
        <MetaContainer>
          <FlagsContainer>
            {templateCodes.map(code => (<Flag languageCode={code}/>))}
          </FlagsContainer>
          <Chip appearance="secondary" label={t({
            comment: 'Composer card - Jurisdiction chip label',
            message: 'Jurisdiction',
        })} secondary={market.getName()}/>
        </MetaContainer>
      </Content>
    </Container>);
}
